import { HelpCircle } from "lucide-react";
import { Button } from "@ndd/ui";

export const LARGE_PASTE_THRESHOLD = 1500;

interface LargePasteBannerProps {
  charCount: number;
  onAttach: () => void;
  onDismiss: () => void;
}

export function LargePasteBanner({
  charCount,
  onAttach,
  onDismiss,
}: LargePasteBannerProps) {
  return (
    <div className="bg-ai-soft rounded-xl py-3 px-4 flex items-center gap-3">
      <HelpCircle className="h-5 w-5 text-ai shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-foreground">
          Did you mean to attach this as a transcript?
        </p>
        <p className="text-sm text-muted-foreground">
          That&apos;s ~{charCount.toLocaleString()} characters — looks like a session
          transcript rather than a chat message.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button type="button" variant="ai" size="sm" onClick={onAttach}>
          Yes, attach it
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={onDismiss}>
          No, keep as message
        </Button>
      </div>
    </div>
  );
}
